// src/components/Layout/Sidebar.js
import React, { useContext, useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Divider,
  Tooltip,
  useTheme,
} from '@mui/material';
import {
  Inventory as InventoryIcon,
  People as PeopleIcon,
  Store as StoreIcon,
  MoveToInbox as MoveIcon,
  AdminPanelSettings as AdminIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { makeStyles } from '@mui/styles';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: (props) => (props.open ? drawerWidth : theme.spacing(7) + 1),
    flexShrink: 0,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerOpen: {
    width: drawerWidth,
  },
  drawerClose: {
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
}));

const Sidebar = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const classes = useStyles({ open });

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const publicMenuItems = [
    {
      text: 'Bodegas',
      icon: <StoreIcon />,
      path: '/bodegas',
    },
    {
      text: 'Movimientos',
      icon: <MoveIcon />,
      path: '/movimientos',
    },
  ];

  const protectedMenuItems = [
    {
      text: 'Productos',
      icon: <InventoryIcon />,
      path: '/products',
      permission: 'crearProductos',
    },
    {
      text: 'Usuarios',
      icon: <PeopleIcon />,
      path: '/users',
      permission: 'crearUsuarios',
    },
    {
      text: 'Roles y Permisos',
      icon: <AdminIcon />,
      path: '/roles',
      permission: 'crearUsuarios',
    },
    // Agrega más ítems protegidos según sea necesario
  ];

  return (
    <Drawer
      variant="permanent"
      className={`${classes.drawer} ${
        open ? classes.drawerOpen : classes.drawerClose
      }`}
      classes={{
        paper: open ? classes.drawerOpen : classes.drawerClose,
      }}
    >
      <div className={classes.toolbar}>
        <IconButton onClick={handleDrawerToggle}>
          {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </div>
      <Divider />
      <List>
        {publicMenuItems.map((item, index) => (
          <ListItem button key={index} onClick={() => navigate(item.path)}>
            <Tooltip title={open ? '' : item.text} placement="right">
              <ListItemIcon>{item.icon}</ListItemIcon>
            </Tooltip>
            {open && <ListItemText primary={item.text} />}
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {protectedMenuItems.map((item, index) => {
          if (user && user.permisos && user.permisos[item.permission]) {
            return (
              <ListItem button key={index} onClick={() => navigate(item.path)}>
                <Tooltip title={open ? '' : item.text} placement="right">
                  <ListItemIcon>{item.icon}</ListItemIcon>
                </Tooltip>
                {open && <ListItemText primary={item.text} />}
              </ListItem>
            );
          }
          return null;
        })}
      </List>
    </Drawer>
  );
};

export default Sidebar;
